module.exports = "<div class=\"video-wrapper\">\n    <div class=\"inside-page-bck\"></div>\n    <div class=\"inside-page-box\">\n        <h3>Видео</h3>\n        <div class=\"video-container\">\n            \n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/+app/+video/video.component.html
// module id = 596
// module chunks = 0